<div class="body" [formGroup]="formGroup">

    <ng-container *ngIf="downloadSucceeded">

        <iframe [src]="objectUrl|async"></iframe>

    </ng-container>

    <ng-container *ngIf="downloading">

        <div class="spacer"></div>
        <mat-spinner diameter=50></mat-spinner>
        <div class="download-hint">
            Es dauert nur einen Moment.
        </div>
        <div class="spacer"></div>

    </ng-container>

    <ng-container *ngIf="downloadFailed">

        <div class="spacer"></div>
        <div class="error-hint">
            Die Datei kann nicht angezeigt werden, da beim Herunterladen ein Fehler aufgetreten ist.
        </div>
        <div class="spacer"></div>

    </ng-container>

    <ng-container *ngIf="wrongSetup">

        <div class="spacer"></div>
        <div class="error-hint">
            Die Datei kann nicht angezeigt werden, da ein Problem im Client aufgetreten ist.
        </div>
        <div class="spacer"></div>

    </ng-container>

</div>